import {
  BoldSubHeading,
  DateField,
  Section,
  SectionDivider,
  TabPanel,
  TextField,
} from '@dispatch/web/ui';
import { Box, Grid } from '@mui/material';
import { Control, FieldErrors, FieldValues } from 'react-hook-form';

export const GeneralInformation = function ({
  currentTab,
  errors,
  control,
}: {
  currentTab: number;
  errors: FieldErrors;
  control: Control<FieldValues>;
}) {
  return (
    <TabPanel value={currentTab} index={1} data-testid="general-info-tab">
      <Box sx={{ padding: '24px !important' }}>
        <Section title={`Insured`}>
          <BoldSubHeading text="Person #1" />
          <Grid container spacing={2} marginBottom={2}>
            <Grid size={3}>
              <TextField
                id="contact.primary.insuredName"
                name="contact.primary.insuredName"
                label="Insured Name"
                required
                control={control}
                errors={errors}
                sx={{ width: '100%' }}
                disabled
              />
            </Grid>
            <Grid size={3}>
              <TextField
                id="contact.primary.phone"
                name="contact.primary.phone"
                label="Insured Phone Number 1"
                required
                control={control}
                errors={errors}
                sx={{ width: '100%' }}
                disabled
              />
            </Grid>
            <Grid size={3}>
              <TextField
                id="contact.primary.phone2"
                name="contact.primary.phone2"
                label="Insured Phone Number 2"
                control={control}
                errors={errors}
                sx={{ width: '100%' }}
                disabled
              />
            </Grid>
            <Grid size={3}>
              <TextField
                id="contact.primary.email"
                name="contact.primary.email"
                label="Insured Email"
                control={control}
                errors={errors}
                sx={{ width: '100%' }}
                disabled
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="baseline">
            <Grid size={3}>
              <TextField
                id="contact.primary.contactMethod"
                name="contact.primary.contactMethod"
                label="Preferred Method of Contact"
                required
                control={control}
                errors={errors}
                disabled
              />
            </Grid>
            <Grid size={3}>
              <DateField
                disabled
                id="claim.dateOfLoss"
                name="claim.dateOfLoss"
                label="Date of Loss"
                control={control}
              />
            </Grid>
            <Grid size={3}>
              <DateField
                disabled
                id="claim.dateOfNotice"
                name="claim.dateOfNotice"
                label="Date of Notice"
                control={control}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid size={12}>
              <TextField
                multiline
                id="assignmentHandling.notes"
                name="assignmentHandling.notes"
                label="Notes"
                control={control}
                errors={errors}
                disabled
              />
            </Grid>
          </Grid>
        </Section>
        <SectionDivider />
        <Section title="Alternate Contacts">
          <Grid container>
            <Grid container spacing={2} marginBottom={2}>
              <Grid size={4}>
                <TextField
                  id="contact.secondary.insuredName"
                  name="contact.secondary.insuredName"
                  label="Alternate Contact Name"
                  required
                  control={control}
                  errors={errors}
                  sx={{ width: '100%' }}
                  disabled
                />
              </Grid>
              <Grid size={4}>
                <TextField
                  id="contact.secondary.phone"
                  name="contact.secondary.phone"
                  label="Alternate Contact Phone"
                  required
                  control={control}
                  errors={errors}
                  sx={{ width: '100%' }}
                  disabled
                />
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </Box>
    </TabPanel>
  );
};
